import React from 'react'
import ArrowDown from '../../../images/icon_chevron_right.svg'
import { Text } from '../../atoms/text'
import { If } from '../../atoms/if'
import { Tag } from '../../atoms/tag'
import {
  StyledNotificationItemWrapper,
  StyledNotificationImageBox,
  StyledNotificationCtaBox,
  StyledNotificationContentBox,
  StyledNotificationContentFooter,
} from './styles'
import { getNotificationRedirect } from '../../../adapters/notifications'
import dayjs from 'dayjs'
import { useTranslation } from '../../../context/translationProvider'

const dateTimeFormat = 'DD.MM.YYYY. HH:mm'

export const NotificationItem = ({
  title,
  description,
  image,
  category,
  isExpired,
  expireTime,
  isUnread,
  onClose,
  playerNotificationId,
  startDate,
}) => {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const [onlyExpiryDate] = expireTime?.split('.')
  const utcExpiryDate = `${onlyExpiryDate}.000Z`
  const formatedExpireDate = dayjs(new Date(utcExpiryDate)).format(
    dateTimeFormat
  )
  const { translate } = useTranslation()
  const handleClick = async () => {
    if (isExpired) {
      return
    }
    const { data: url } = await getNotificationRedirect({
      playerNotificationId,
      startDate,
    })
    onClose()
    window.location = url
  }

  return (
    <StyledNotificationItemWrapper
      isUnread={isUnread || isExpired}
      onClick={handleClick}
      isExpired={isExpired}
    >
      <StyledNotificationImageBox showBadge={isUnread}>
        <img src={image} alt={title} className={isExpired && 'is-expired'} />
      </StyledNotificationImageBox>
      <StyledNotificationContentBox>
        <Text small theme={isExpired && 'light'}>
          {title}
        </Text>
        <If
          condition={!!description}
          render={() => (
            <Text small theme={isExpired && 'light'}>
              {description}
            </Text>
          )}
        />

        <StyledNotificationContentFooter>
          <Tag
            style={
              isExpired
                ? null
                : {
                    backgroundColor: category?.tagColor,
                    color: category?.fontColor,
                  }
            }
            text={category?.description?.toUpperCase()}
          />
          <Text small theme="light" noMargin>
            <If
              condition={isExpired}
              render={() =>
                `${translate('playerInbox.expired')}: ${formatedExpireDate}`
              }
              renderElse={() =>
                `${translate('playerInbox.expires')}: ${formatedExpireDate}`
              }
            />
          </Text>
        </StyledNotificationContentFooter>
      </StyledNotificationContentBox>
      <If
        condition={!isExpired}
        render={() => (
          <StyledNotificationCtaBox>
            <img src={ArrowDown} className={!isUnread && 'is-unread'} />
          </StyledNotificationCtaBox>
        )}
      />
    </StyledNotificationItemWrapper>
  )
}
